import { PASSWORD_UPDATED_AT, PASSWORD_VALIDITY_DAYS } from './constants';

/**
 * Calcula estado de caducidad de la contraseña
 * @returns {{ expired: boolean, expiresInDays: number | null }}
 */
export function getPasswordStatus() {
  const updatedAtRaw = localStorage.getItem(PASSWORD_UPDATED_AT);
  if (!updatedAtRaw) return { expired: false, expiresInDays: null };

  const updatedMs = new Date(updatedAtRaw).getTime();
  const daysSince = Math.floor((Date.now() - updatedMs) / (1000 * 60 * 60 * 24));
  const expiresInDays = PASSWORD_VALIDITY_DAYS - daysSince;
  return { expired: expiresInDays <= 0, expiresInDays };
}
